const GRAPHQL = 'GRAPHQL';
const DOMAINS = {
  BOOKING: 'BOOKING',
  COMMON: 'COMMON',
  CORE: 'CORE',
  CRUISE: 'CRUISE',
  CUSTOMER_ACCOUNT: 'CUSTOMER_ACCOUNT',
  CUSTOMER_BOOKING: 'CUSTOMER_BOOKING',
  DATA: 'DATA',
  LINE: 'LINE',
  NEWSLETTER: 'NEWSLETTER',
  OFFER: 'OFFER',
  PAGE: 'PAGE',
  PAYMENT: 'PAYMENT',
  PRODUCT: 'PRODUCT',
  PROPOSAL: 'PROPOSAL',
  QRCODE: 'QRCODE',
  SEARCH: 'SEARCH',
  SELLER: 'SELLER',
  STATE: 'STATE',
  STREET_VIEW: 'STREET_VIEW',
  TOUR: 'TOUR',
  WIDGET: 'WIDGET',
  SCHEMA: 'SCHEMA',
};
const {
  COMMON,
  CORE,
  CRUISE,
  CUSTOMER_ACCOUNT,
  CUSTOMER_BOOKING,
  DATA,
  LINE,
  NEWSLETTER,
  OFFER,
  PAGE,
  PAYMENT,
  PRODUCT,
  PROPOSAL,
  QRCODE,
  SEARCH,
  STATE,
  STREET_VIEW,
  TOUR,
  WIDGET,
  SCHEMA,
} = DOMAINS;
// Helpers
export function getName(path: Array<string>) {
  return path
    .filter(Boolean)
    .map((x) => x.toUpperCase())
    .join('|');
}
export function getGqlName(path: Array<string>) {
  return getName([GRAPHQL, ...path]);
}
// PAGES
export const PAGE_404 = getGqlName([PAGE, '404']);
export const PAGE_ARTICLE = getGqlName([PAGE, 'ARTICLE']);
export const PAGE_CRUISE = getGqlName([PAGE, 'CRUISE']);
export const PAGE_DYNAMIC = getGqlName([PAGE, 'DYNAMIC']);
export const PAGE_HOME = getGqlName([PAGE, 'HOME']);
export const PAGE_SEARCH = getGqlName([PAGE, 'SEARCH']);
export const PAGE_SITEMAP = getGqlName([PAGE, 'SITEMAP']);
export const PAGE_SITEPLAN = getGqlName([PAGE, 'SITEPLAN']);
export const PAGE_THEME = getGqlName([PAGE, 'THEME']);
// LINES
export const LINE_COMMON_COMPARISON_TABLE = getGqlName([LINE, COMMON, 'COMPARISON_TABLE']);
export const LINE_COMMON_DESTINATIONS = getGqlName([LINE, COMMON, 'DESTINATIONS']);
export const LINE_COMMON_EVENT_FORM = getGqlName([LINE, COMMON, 'EVENT_FORM']);
export const LINE_COMMON_EVENT_FORM_AFFINITY = getGqlName([LINE, COMMON, 'EVENT_FORM_AFFINITY']);
export const LINE_COMMON_IMMERSIVE = getGqlName([LINE, COMMON, 'IMMERSIVE']);
export const LINE_COMMON_INSTAGRAM = getGqlName([LINE, COMMON, 'INSTAGRAM']);
export const LINE_COMMON_LAST_SEEN_PRODUCTS = getGqlName([LINE, COMMON, 'LAST_SEEN_PRODUCTS']);
export const LINE_COMMON_PRODUCT_GRID_IDS = getGqlName([LINE, COMMON, 'PRODUCT_GRID_IDS']);
export const LINE_COMMON_PRODUCT_GRID_IDS_WITH_OFFER = getGqlName([
  LINE,
  COMMON,
  'PRODUCT_GRID_IDS_WITH_OFFER',
]);
export const LINE_COMMON_PRODUCT_GRID_PRODUCTS = getGqlName([
  LINE,
  COMMON,
  'PRODUCT_GRID_PRODUCTS',
]);
export const LINE_COMMON_PRODUCT_GRID_THUMBNAIL_TRADS = getGqlName([
  LINE,
  COMMON,
  'PRODUCT_GRID_THUMBNAIL_TRADS',
]);
export const LINE_COMMON_PRODUCT_TAGS = getGqlName([LINE, COMMON, 'PRODUCT_TAGS']);
export const LINE_COMMON_TEASER_CARDS = getGqlName([LINE, COMMON, 'TEASER_CARDS']);
export const LINE_COMMON_THEMATIC = getGqlName([LINE, COMMON, 'THEMATIC']);
export const LINE_COMMON_TRACKING = getGqlName([LINE, COMMON, 'TRACKING']);
export const LINE_COMMON_TRAVEL_RESTRICTIONS = getGqlName([LINE, COMMON, 'TRAVEL_RESTRICTIONS']);
export const LINE_HAPPY_TO_CARE = getGqlName([LINE, COMMON, 'HAPPY_TO_CARE']);
export const LINE_OFFER_DESCRIPTION = getGqlName([LINE, OFFER, 'DESCRIPTION']);
export const LINE_OFFER_GRID = getGqlName([LINE, OFFER, 'GRID']);
export const LINE_OFFER_LEGAL_INFORMATION = getGqlName([LINE, OFFER, 'LEGAL_INFORMATION']);
export const LINE_OFFER_PRODUCT_FILTER = getGqlName([LINE, OFFER, 'PRODUCT_FILTER']);
export const LINE_OFFER_SEO = getGqlName([LINE, OFFER, 'SEO']);
export const LINE_OFFER_TRACKING = getGqlName([LINE, OFFER, 'TRACKING']);
export const LINE_PRODUCT_ACCESS_AND_MAP = getGqlName([LINE, PRODUCT, 'ACCESS_AND_MAP']);
export const LINE_PRODUCT_ACCOMMODATIONS = getGqlName([LINE, PRODUCT, 'ACCOMMODATIONS']);
export const LINE_PRODUCT_ACCOMMODATIONS_STREETVIEWS = getGqlName([
  LINE,
  PRODUCT,
  'ACCOMMODATIONS_STREETVIEWS',
]);
export const LINE_PRODUCT_ACTIVITIES = getGqlName([LINE, PRODUCT, 'ACTIVITIES']);
export const LINE_PRODUCT_BARS = getGqlName([LINE, PRODUCT, 'BARS']);
export const LINE_PRODUCT_BOOKING = getGqlName([LINE, PRODUCT, 'BOOKING']);
export const LINE_PRODUCT_BREADCRUMB = getGqlName([LINE, PRODUCT, 'BREADCRUMB']);
export const LINE_PRODUCT_CHILDCARE = getGqlName([LINE, PRODUCT, 'CHILDCARE']);
export const LINE_PRODUCT_DESTINATIONS = getGqlName([LINE, PRODUCT, 'DESTINATIONS']);
export const LINE_RESORT_DISTRICT = getGqlName([LINE, PRODUCT, 'DISTRICT']);
export const LINE_PRODUCT_EXCLUSIVE_COLLECTION_SPACE = getGqlName([
  LINE,
  PRODUCT,
  'EXCLUSIVE_COLLECTION_SPACE',
]);
export const LINE_PRODUCT_EXCLUSIVE_COLLECTION_SPACE_INTRODUCTION = getGqlName([
  LINE,
  PRODUCT,
  'EXCLUSIVE_COLLECTION_SPACE_INTRODUCTION',
]);
export const LINE_PRODUCT_FLASH_INFO = getGqlName([LINE, PRODUCT, 'FLASH_INFO']);
export const LINE_PRODUCT_IMAGE_MAP = getGqlName([LINE, PRODUCT, 'IMAGE_MAP']);
export const LINE_PRODUCT_IMMERSIVE = getGqlName([LINE, PRODUCT, 'IMMERSIVE']);
export const LINE_PRODUCT_INFORMATION_SUMMARY = getGqlName([LINE, PRODUCT, 'INFORMATION_SUMMARY']);
export const LINE_PRODUCT_INSTAGRAM_GRID = getGqlName([LINE, PRODUCT, 'INSTAGRAM_GRID']);
export const LINE_PRODUCT_INTRODUCTION = getGqlName([LINE, PRODUCT, 'INTRODUCTION']);
export const LINE_PRODUCT_MEETING_ROOM_INFO = getGqlName([LINE, PRODUCT, 'MEETING_ROOM_INFO']);
export const LINE_PRODUCT_MULTIMEDIA = getGqlName([LINE, PRODUCT, 'MULTIMEDIA']);
export const LINE_PRODUCT_MUST_TRY_EXPERIENCES = getGqlName([
  LINE,
  PRODUCT,
  'MUST_TRY_EXPERIENCES',
]);
export const LINE_PRODUCT_PRICE_REMOTE = getGqlName([LINE, PRODUCT, 'PRICE_REMOTE']);
export const LINE_PRODUCT_PRICE_TICKET = getGqlName([LINE, PRODUCT, 'PRICE_TICKET']);
export const LINE_PRODUCT_PRICE_TICKET_CUSTOM = getGqlName([LINE, PRODUCT, 'PRICE_TICKET_CUSTOM']);
export const LINE_PRODUCT_QUOTATION_FORM = getGqlName([LINE, PRODUCT, 'QUTATION_FORM']);
export const LINE_PRODUCT_RECOMMENDATIONS = getGqlName([LINE, PRODUCT, 'RECOMMENDATIONS']);
export const LINE_PRODUCT_RELATED_PRODUCTS = getGqlName([LINE, PRODUCT, 'RELATED_PRODUCTS']);
export const LINE_PRODUCT_RESTAURANTS = getGqlName([LINE, PRODUCT, 'RESTAURANTS']);
export const LINE_PRODUCT_SEO_TITLE = getGqlName([LINE, PRODUCT, 'SEO_TITLE']);
export const LINE_PRODUCT_SERVICES = getGqlName([LINE, PRODUCT, 'SERVICES']);
export const LINE_PRODUCT_STREET_VIEW = getGqlName([LINE, PRODUCT, 'STREET_VIEW']);
export const LINE_PRODUCT_STRENGTHS = getGqlName([LINE, PRODUCT, 'STRENGTHS']);
export const LINE_PRODUCT_SUMMARY = getGqlName([LINE, PRODUCT, 'SUMMARY']);
export const LINE_PRODUCT_TRIPADVISOR = getGqlName([LINE, PRODUCT, 'TRIPADVISOR']);
export const LINE_QRCODE_PRODUCT_BARS = getGqlName([LINE, QRCODE, 'PRODUCT_BARS']);
export const LINE_QRCODE_PRODUCT_DRESSCODE = getGqlName([LINE, QRCODE, 'PRODUCT_DRESSCODE']);
export const LINE_QRCODE_PRODUCT_PROGRAM = getGqlName([LINE, QRCODE, 'PRODUCT_PROGRAM']);
export const LINE_QRCODE_PRODUCT_RESTAURANTS = getGqlName([LINE, QRCODE, 'PRODUCT_RESTAURANTS']);
export const LINE_CRUISE_BOOKING = getGqlName([LINE, CRUISE, 'BOOKING']);
export const LINE_CRUISE_PROGRAM = getGqlName([LINE, CRUISE, 'PROGRAM']);
export const LINE_CRUISE_EXCLUSIVITY = getGqlName([LINE, CRUISE, 'EXCLUSIVITY']);
export const LINE_TOUR_INTRODUCTION = getGqlName([LINE, TOUR, 'INRODUCTION']);
export const LINE_TOUR_PRACTICAL_INFO = getGqlName([LINE, TOUR, 'PRACTICAL_INFO']);
export const LINE_TOUR_PROGRAM = getGqlName([LINE, TOUR, 'PROGRAM']);
// REDUX REQUESTS
export const STATE_PRODUCT_ALL_INCLUSIVE_SERVICES = getGqlName([
  STATE,
  PRODUCT,
  'ALL_INCLUSIVE_SERVICES',
]);
export const STATE_PRODUCT_BOOKABLE_DATES = getGqlName([STATE, PRODUCT, 'BOOKABLE_DATES']);
export const STATE_PRODUCT_CALENDAR = getGqlName([STATE, PRODUCT, 'CALENDAR']);
export const STATE_PRODUCT_PRICE_TICKET = getGqlName([STATE, PRODUCT, 'PRICE_TICKET']);
export const STATE_PRODUCT_PRICE_OF_STAY = getGqlName([STATE, PRODUCT, 'PRICE_OF_STAY']);
export const STATE_SEARCH_FACETING_TOP_COUNTRIES = getGqlName([
  STATE,
  SEARCH,
  'FACETING_TOP_COUNTRIES',
]);
export const STATE_SEARCH_OFFSET_SELL = getGqlName([STATE, SEARCH, 'OFFSET_SELL']);
export const STATE_SEARCH_PRODUCT_CHILDCARE = getGqlName([STATE, SEARCH, 'PRODUCT_CHILDCARE']);
export const STATE_SEARCH_PRODUCT_CONFIG = getGqlName([STATE, SEARCH, 'PRODUCT_CONFIG']);
export const STATE_SEARCH_PRODUCTS = getGqlName([STATE, SEARCH, 'PRODUCTS']);
export const STATE_SEARCH_PRODUCT_PRICE = getGqlName([STATE, SEARCH, 'PRODUCT_PRICE']);
// WIDGET REQUESTS
export const WIDGET_CRUISE_BOOKING_CALL_PRICE = getGqlName([
  WIDGET,
  'CRUISE_BOOKING',
  'CALL_PRICE',
]);
export const WIDGET_EVENT_FORM_SUBMIT = getGqlName([WIDGET, 'EVENT_FORM', 'SUBMIT']);
export const WIDGET_PRODUCT_ACTIVITIES_FETCH_SERVICES = getGqlName([
  WIDGET,
  'PRODUCT_ACTIVITIES',
  'FETCH_SERVICES',
]);
export const WIDGET_PRODUCT_FETCH_INFORMATION_BANNERS = getGqlName([
  WIDGET,
  'PRODUCT',
  'FETCH_INFORMATION_BANNERS',
]);
export const WIDGET_QUOTATION_FORM_SUBMIT = getGqlName([WIDGET, 'QUOTATION_FORM', 'SUBMIT']);
export const WIDGET_QUOTATION_FORM_TRACK = getGqlName([WIDGET, 'QUOTATION_FORM', 'TRACK']);
export const WIDGET_WEBCALLBACK_OPENING_HOURS = getGqlName([
  WIDGET,
  'WEBCALLBACK',
  'OPENING_HOURS',
]);
export const WIDGET_WEBCALLBACK_SCHEDULE_CALL = getGqlName([
  WIDGET,
  'WEBCALLBACK',
  'SCHEDULE_CALL',
]);
// CORE
export const CORE_GET_FEATURE_FLIPPING_KEYS = getGqlName([CORE, 'FEATURE_FLIPPING_KEYS']);
export const CORE_LAYOUT = getGqlName([CORE, 'LAYOUT']);
export const CORE_GET_COMMON_I18N = getGqlName([CORE, 'I18N']);
export const CORE_GET_FACEBOOK_CONNECT_CONFIG = getGqlName([CORE, 'GET_FACEBOOK_CONNECT_CONFIG']);
export const BOOKING_GET_BOOKING_I18N = getGqlName([DOMAINS.BOOKING, 'GET_BOOKING_I18N']);
export const BE_GM_GET_POINTS = getGqlName([DOMAINS.BOOKING, 'GM_GET_POINTS']);
// CUSTOMER ACCOUNT
export const CUSTOMER_ACCOUNT_GET_BOOKING_LOYALTY_DATA = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET_BOOKING_LOYALTY',
]);
export const CUSTOMER_ACCOUNT_GET_BOOKING_PAYMENT_DETAILS = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET_BOOKING_PAYMENT_DETAILS',
]);
export const CUSTOMER_ACCOUNT_GET_BOOKING_TRANSPORT_DATA = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET_BOOKING_TRANSPORT',
]);
export const CUSTOMER_ACCOUNT_GET_IMMERSIVE_PICTURES = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET_IMMERSIVE_PICTURES',
]);
export const CUSTOMER_ACCOUNT_GET_BOOKMARKS = getGqlName([CUSTOMER_ACCOUNT, 'GET_BOOKMARKS']);
export const CUSTOMER_ACCOUNT_GET_FUTURE_TRIPS = getGqlName([CUSTOMER_ACCOUNT, 'FUTURE_TRIPS']);
export const CUSTOMER_ACCOUNT_GET_PAST_TRIPS = getGqlName([CUSTOMER_ACCOUNT, 'PAST_TRIPS']);
export const CUSTOMER_ACCOUNT_GET_CANCELED_TRIPS = getGqlName([CUSTOMER_ACCOUNT, 'CANCELED_TRIPS']);
export const CUSTOMER_ACCOUNT_GET_CURRENT_TRIPS = getGqlName([CUSTOMER_ACCOUNT, 'CURRENT_TRIPS']);
export const CUSTOMER_ACCOUNT_GET_PROFILE_DATA = getGqlName([CUSTOMER_ACCOUNT, 'GET_PROFILE_DATA']);
export const CUSTOMER_ACCOUNT_GET_PROFILE_NEWSLETTER_CONFIG = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET_PROFILE_NEWSLETTER_CONFIG',
]);
export const CUSTOMER_ACCOUNT_GET_SEARCHES = getGqlName([CUSTOMER_ACCOUNT, 'GET_SEARCHES']);
export const CUSTOMER_ACCOUNT_GET_CMS_DATA = getGqlName([CUSTOMER_ACCOUNT, 'GET_CMS_DATA']);
export const CUSTOMER_ACCOUNT_GET_CMS_DATA_GREAT_MEMBER = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET_CMS_DATA_GREAT_MEMBER',
]);
export const CUSTOMER_ACCOUNT_GET_CMS_DATA_BOOKING_VIEW = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET_CMS_DATA_BOOKING_VIEW',
]);
export const CUSTOMER_ACCOUNT_GET_CMS_DATA_PREPAYMENT = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET_CMS_DATA_PREPAYMENT',
]);
export const CUSTOMER_ACCOUNT_GET_CMS_DATA_GREATMEMBERS = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET_CMS_DATA_GREATMEMBERS',
]);
export const CUSTOMER_ACCOUNT_GET_SPONSORSHIP_PROGRAM = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET_SPONSORSHIP_PROGRAM',
]);
export const CUSTOMER_ACCOUNT_GET_TRAVEL_COMPANIONS = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET_TRAVEL_COMPANIONS',
]);
export const CUSTOMER_ACCOUNT_GET_ADDRESS_SCHEMA = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET__ADDRESS_SCHEMA',
]);
export const CUSTOMER_ACCOUNT_GM_GET_POINTS = getGqlName([CUSTOMER_ACCOUNT, 'GM_GET_POINTS']);
export const CUSTOMER_ACCOUNT_GET_CMS_CONTENT_TRANSFER = getGqlName([
  CUSTOMER_ACCOUNT,
  'GM_GET_CMS_CONTENT_TRANSFER',
]);
export const CUSTOMER_ACCOUNT_GET_TRANSFER_DETAILS = getGqlName([
  CUSTOMER_ACCOUNT,
  'GM_GET_TRANSFER_DETAILS',
]);
export const CUSTOMER_ACCOUNT_SUBMIT_FORM_SPONSOR_A_FRIEND = getGqlName([
  CUSTOMER_ACCOUNT,
  'SUBMIT_FORM_SPONSOR_A_FRIEND',
]);
export const CUSTOMER_ACCOUNT_UPDATE_PASSPORT = getGqlName([CUSTOMER_ACCOUNT, 'UPDATE_PASSPORT']);
export const CUSTOMER_ACCOUNT_UPDATE_PERSONAL_INFO = getGqlName([
  CUSTOMER_ACCOUNT,
  'UPDATE_PERSONAL_INFO',
]);
export const CUSTOMER_ACCOUNT_PROFILE_VIEW_RESOLVER = getGqlName([
  CUSTOMER_ACCOUNT,
  'PROFILE_VIEW_RESOLVER',
]);
export const CUSTOMER_ACCOUNT_GET_DASHBOARD_FUTURE_TRIPS = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET_DASHBOARD_FUTURE_TRIPS',
]);
export const CUSTOMER_ACCOUNT_GET_DASHBOARD_CURRENT_TRIPS = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET_DASHBOARD_CURRENT_TRIPS',
]);
export const CUSTOMER_ACCOUNT_GET_DASHBOARD_PROFILE = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET_DASHBOARD_PROFILE',
]);
export const CUSTOMER_ACCOUNT_GET_CUSTOMERS = getGqlName([CUSTOMER_ACCOUNT, 'GET_CUSTOMERS']);
export const CUSTOMER_ACCOUNT_GET_QUICK_DASHBOARD_CUSTOMER = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET_QUICK_DASHBOARD_CUSTOMER',
]);
export const CUSTOMER_ACCOUNT_GET_VOUCHERS = getGqlName([CUSTOMER_ACCOUNT, 'GET_VOUCHERS']);
export const CUSTOMER_ACCOUNT_GET_BOOKINGS_CART = getGqlName([CUSTOMER_ACCOUNT, 'BOOKINGS_CART']);
export const CUSTOMER_ACCOUNT_GET_LOYALTY_DETAILS = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET_LOYALTY_DETAILS',
]);
export const CUSTOMER_ACCOUNT_GET_LOYALTY_PROGRAM = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET_LOYALTY_PROGRAM',
]);
export const CUSTOMER_ACCOUNT_GET_BOOKING_DATA = getGqlName([CUSTOMER_ACCOUNT, 'GET_BOOKING_DATA']);
export const CUSTOMER_ACCOUNT_GET_MUSTTRY_EXPERIENCES_DATA = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET_MUSTTRY_EXPERIENCES_DATA',
]);
export const CUSTOMER_ACCOUNT_GET_BOOKING_CHILDCARE = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET_BOOKING_CHILDCARE',
]);
export const CUSTOMER_ACCOUNT_GET_AVAILABLE_RENTALS = getGqlName([
  CUSTOMER_ACCOUNT,
  'GET_AVAILABLE_RENTALS',
]);
export const CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART = getGqlName([
  CUSTOMER_ACCOUNT,
  'UPDATE_BOOKING_CART',
]);
export const CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM = getGqlName([
  CUSTOMER_ACCOUNT,
  'REMOVE_BOOKING_CART_ITEM',
]);
// CUSTOMER BOOKING
export const CUSTOMER_BOOKING_AUTHORIZATION_NOTIFY = getGqlName([
  CUSTOMER_BOOKING,
  'AUTHORIZATION_NOTIFY',
]);
export const CUSTOMER_BOOKING_AUTHORIZATION_REDIRECT = getGqlName([
  CUSTOMER_BOOKING,
  'AUTHORIZATION_REDIRECT',
]);
export const CUSTOMER_BOOKING_GET_ACTIVITIES = getGqlName([CUSTOMER_BOOKING, 'GET_ACTIVITIES']);
export const CUSTOMER_BOOKING_GET_ATTENDEES = getGqlName([CUSTOMER_BOOKING, 'GET_ATTENDEES']);
export const CUSTOMER_BOOKING_GET_STAY_FORMALITIES = getGqlName([
  CUSTOMER_BOOKING,
  'GET_STAY_FORMALITIES',
]);
export const CUSTOMER_BOOKING_GET_UPGRADEROOM = getGqlName([CUSTOMER_BOOKING, 'GET_UPGRADEROOM']);
export const CUSTOMER_BOOKING_GET_AVAILABLE_RENTAL_EQUIPMENTS = getGqlName([
  CUSTOMER_BOOKING,
  'GET_AVAILABLE_RENTAL_EQUIPMENTS',
]);
export const CUSTOMER_BOOKING_GET_DASHBOARD_DATA = getGqlName([
  CUSTOMER_BOOKING,
  'GET_DASHBOARD_DATA',
]);
export const CUSTOMER_BOOKING_GET_DATA = getGqlName([CUSTOMER_BOOKING, 'GET_DATA']);
export const CUSTOMER_BOOKING_GET_DOCUMENTS = getGqlName([
  CUSTOMER_BOOKING,
  'GET_BOOKING_DOCUMENTS',
]);
export const CUSTOMER_BOOKING_GET_PRICE_AND_PAYMENT_DATA = getGqlName([
  CUSTOMER_BOOKING,
  'GET_BOOKING_PRICE_AND_PAYMENT_DATA',
]);
export const CUSTOMER_BOOKING_GET_MORE_ACCOMMODATIONS_DATA = getGqlName([
  CUSTOMER_BOOKING,
  'GET_MORE_ACCOMMODATIONS_DATA',
]);
export const CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_DATA = getGqlName([
  CUSTOMER_BOOKING,
  'PREBOOKING_FETCH_DATA',
]);
export const CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_RESORTS = getGqlName([
  CUSTOMER_BOOKING,
  'PREBOOKING_FETCH_RESORTS',
]);
export const CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_TRAVELERS = getGqlName([
  CUSTOMER_BOOKING,
  'PREBOOKING_FETCH_TRAVELERS',
]);
export const CUSTOMER_BOOKING_PREBOOKING_FORM_SUBMIT = getGqlName([
  CUSTOMER_BOOKING,
  'PREBOOKING_FORM_SUBMIT',
]);
export const CUSTOMER_BOOKING_PREPARE_MY_STAY = getGqlName([CUSTOMER_BOOKING, 'PREPARE_MY_STAY']);
export const CUSTOMER_BOOKING_PREPARE_MY_STAY_GET_STAY_FORMALITIES = getGqlName([
  CUSTOMER_BOOKING,
  'PREPARE_MY_STAY_GET_STAY_FORMALITIES',
]);
export const CUSTOMER_BOOKING_RD_GET_RESORT_SETTINGS = getGqlName([
  CUSTOMER_BOOKING,
  'RD_GET_RESORT_SETTINGS',
]);
export const CUSTOMER_BOOKING_UPDATE_CHECKOUT = getGqlName([CUSTOMER_BOOKING, 'UPDATE_CHECKOUT']);
export const CUSTOMER_BOOKING_UPDATE_TRANSFER = getGqlName([CUSTOMER_BOOKING, 'UPDATE_TRANSFER']);
export const CUSTOMER_BOOKING_SHARE = getGqlName([CUSTOMER_BOOKING, 'SHARE']);
export const CUSTOMER_OPTION_RENEW = getGqlName([CUSTOMER_BOOKING, 'RENEW']);
export const CUSTOMER_BOOKING_OPTION_CONFIRMATION_VIEW_RESOLVER = getGqlName([
  CUSTOMER_BOOKING,
  'OPTION_CONFIRMATION_VIEW_RESOLVER',
]);
export const PROPOSAL_OPTION_VALIDITY = getGqlName([PROPOSAL, 'OPTION_VALIDITY']);
export const CUSTOMER_BY_HOME = getGqlName([CUSTOMER_BOOKING, 'CUSTOMER_BY_HOME']);
export const CRITERIA_OFFSETSELL = getGqlName([CUSTOMER_BOOKING, 'CRITERIA_OFFSETSELL']);
export const CRITERIA_DEPARTURE_CITIES = getGqlName([
  CUSTOMER_BOOKING,
  'CRITERIA_DEPARTURE_CITIES',
]);
export const GET_PARTNER_AGENCY = getGqlName([CUSTOMER_BOOKING, 'GET_PARTNER_AGENCY']);
// NEWSLETTER
export const NEWSLETTER_GET_SUBSCRIPTIONS = getGqlName([NEWSLETTER, 'GET_SUBSCRIPTIONS']);
export const NEWSLETTER_SUBMIT_SUBSCRIPTION = getGqlName([NEWSLETTER, 'SUBMIT_SUBSCRIPTION']);
export const NEWSLETTER_SUBMIT_SUBSCRIPTION_QUOTATION_FORM = getGqlName([
  NEWSLETTER,
  'SUBMIT_SUBSCRIPTION_QUOTATION_FORM',
]);
export const NEWSLETTER_SUBSCRIPTION_VIEW_RESOLVER = getGqlName([
  NEWSLETTER,
  'SUBSCRIPTION_VIEW_RESOLVER',
]);
export const NEWSLETTER_CONFIRM_SUBSCRIPTION_VIEW_RESOLVER = getGqlName([
  NEWSLETTER,
  'CONFIRM_SUBSCRIPTION_VIEW_RESOLVER',
]);
export const NEWSLETTER_SUBMIT_QUOTATION_FORM = getGqlName([NEWSLETTER, 'SUBMIT_QUOTATION_FORM']);
// PAYMENT
export const PAYMENT_APPROVE = getGqlName([PAYMENT, 'APPROVE']);
export const PAYMENT_CONFIRMATION_GET_BOOKING_DATA = getGqlName([
  PAYMENT,
  'CONFIRMATION_GET_BOOKING_DATA',
]);
export const PAYMENT_CONFIRMATION_GET_TRACKING_DATA = getGqlName([
  PAYMENT,
  'CONFIRMATION_GET_TRACKING_DATA',
]);
export const PAYMENT_GET_STATUS = getGqlName([PAYMENT, 'GET_STATUS']);
export const PAYMENT_INFO = getGqlName([PAYMENT, 'INFO']);
export const PAYMENT_INIT = getGqlName([PAYMENT, 'INIT']);
export const PAYMENT_NOTIFY_MUTATION = getGqlName([PAYMENT, 'NOTIFY_MUTATION']);
export const PAYMENT_STATUS_MUTATION = getGqlName([PAYMENT, 'STATUS_MUTATION']);
export const PAYMENT_POLLING_GET_STATUS = getGqlName([PAYMENT, 'POLLING_GET_STATUS']);
export const PAYMENT_PRE_GET_DETAILS = getGqlName([PAYMENT, 'PRE_GET_DETAILS']);
export const PAYMENT_PRE_GET_FORM_DATA = getGqlName([PAYMENT, 'PRE_GET_FORM_DATA']);
export const PAYMENT_REDIRECT = getGqlName([PAYMENT, 'REDIRECT']);
export const PAYMENT_STATUS = getGqlName([PAYMENT, 'STATUS']);
export const PAYMENT_CLEAN_CART = getGqlName([PAYMENT, 'CLEAN_CART']);
export const PAYMENT_BOOKING_STATUS = getGqlName([PAYMENT, 'BOOKING_STATUS']);
// TRANSPORT_STATIONS
export const CITIES_GET_TRANSPORT_STATIONS = getGqlName([PROPOSAL, 'GET_TRANSPORT_STATIONS']);
// PROPOSAL
export const PROPOSAL_ACCOMMODATION_ADD = getGqlName([PROPOSAL, 'ACCOMMODATION_ADD']);
export const PROPOSAL_ADD_TRANSPORT = getGqlName([PROPOSAL, 'ADD_TRANSPORT']);
export const PROPOSAL_GET_ADDITIONAL_ACCOMMODATIONS = getGqlName([
  PROPOSAL,
  'GET_ADDITIONAL_ACCOMMODATIONS',
]);
export const PROPOSAL_GET_ADDITIONAL_TRANSPORT = getGqlName([PROPOSAL, 'GET_ADDITIONAL_TRANSPORT']);
export const PROPOSAL_ADD_RENTAL_EQUIPMENT = getGqlName([PROPOSAL, 'ADD_RENTAL_EQUIPMENT']);
export const PROPOSAL_REMOVE_RENTAL_EQUIPMENT = getGqlName([PROPOSAL, 'REMOVE_RENTAL_EQUIPMENT']);
export const PROPOSAL_GET_AVAILABLE_RENTAL_EQUIPMENTS = getGqlName([
  PROPOSAL,
  'GET_AVAILABLE_RENTAL_EQUIPMENTS',
]);
export const PROPOSAL_GET_BY_ID = getGqlName([PROPOSAL, 'GET_BY_ID']);
export const PROPOSAL_GET_ONE = getGqlName([PROPOSAL, 'GET_ONE']);
export const PROPOSAL_GET_SEVERAL = getGqlName([PROPOSAL, 'GET_SEVERAL']);
export const PROPOSAL_GET_SCHEMA = getGqlName([SCHEMA, 'GET_SCHEMA']);
export const PROPOSAL_LINE_BOOKING_SUMMARY = getGqlName([PROPOSAL, 'LINE_BOOKING_SUMMARY']);
export const PROPOSAL_LINE_CONFIRMATION = getGqlName([PROPOSAL, 'LINE_CONFIRMATION']);
export const PROPOSAL_LINE_PAYMENT_INFO = getGqlName([PROPOSAL, 'LINE_PAYMENT_INFO']);
export const PROPOSAL_LINE_PAYMENT_INFO_TRACKING = getGqlName([
  PROPOSAL,
  'LINE_PAYMENT_INFO_TRACKING',
]);
export const PROPOSAL_LINE_PRICE_HEADER = getGqlName([PROPOSAL, 'LINE_PRICE_HEADER']);
export const PROPOSAL_SAVE = getGqlName([PROPOSAL, 'SAVE']);
export const PROPOSAL_OPPORTUNITYID_SAVE = getGqlName([PROPOSAL, 'OPPORTUNITYID_SAVE']);
export const PROPOSAL_UPDATE = getGqlName([PROPOSAL, 'UPDATE']);
export const PROPOSAL_UPDATE_TRANSFER = getGqlName([PROPOSAL, 'UPDATE_TRANSFER']);
export const PROPOSAL_USE_PROMO_CODE = getGqlName([PROPOSAL, 'USE_PROMO_CODE']);
export const PROPOSAL_AUTOSAVE = getGqlName([PROPOSAL, 'AUTOSAVE']);
export const PROPOSAL_GET_SCHEDULE_PAYMENT = getGqlName([PROPOSAL, 'GET_SCHEDULE_PAYMENT']);
export const PROPOSAL_UPDATE_ATTENDEES = getGqlName([PROPOSAL, 'UPDATE_ATTENDEES']);
export const PROPOSAL_UPDATE_INSURANCES = getGqlName([PROPOSAL, 'UPDATE_INSURANCES']);
export const PROPOSAL_DELETE_INSURANCES = getGqlName([PROPOSAL, 'DELETE_INSURANCES']);
export const PROPOSAL_SWITCH_OFFER = getGqlName([PROPOSAL, 'SWITCH_OFFER']);
export const PROPOSAL_ADDITIONAL_SERVICES_ADD = getGqlName([
  PROPOSAL,
  'PROPOSAL_ADDITIONAL_SERVICES_ADD',
]);
export const PROPOSAL_ADDITIONAL_SERVICES_UPDATE = getGqlName([
  PROPOSAL,
  'PROPOSAL_ADDITIONAL_SERVICES_UPDATE',
]);
export const PROPOSAL_ADDITIONAL_SERVICES_DELETE = getGqlName([
  PROPOSAL,
  'PROPOSAL_ADDITIONAL_SERVICES_DELETE',
]);
export const SELLER_PREBOOKING_FORM_SUCCESS = getGqlName([
  DOMAINS.SELLER,
  'SELLER_PREBOOKING_FORM_SUCCESS',
]);
export const STREET_VIEW_GET_SEVERAL = getGqlName([STREET_VIEW, 'GET_SEVERAL']);
export const PROPOSAL_REFRESH = getGqlName([PROPOSAL, 'PROPOSAL_REFRESH']);
// DATA
export const GET_PRODUCT_HAPPY_TO_CARE = getGqlName([DATA, PRODUCT, 'HAPPY_TO_CARE']);
export const GET_USER_PERSONALIZATION = getGqlName([DATA, 'GET_USER_PERSONALIZATION']);
